import { Form, Input } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { ErrorStatus } from '../../../models/index';
import { ConfirmGroupButton } from '../../../elements/confim-group-button';

export function ErrorStatusEditPage(props: {
  errorStatus?: ErrorStatus;
  onSaved: (errorStatus?: ErrorStatus) => void;
  onCancel: () => void;
}) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.errorStatus) {
      apiClient
        .post('error-statuses', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`error-statuses/${props.errorStatus?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={props.errorStatus}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 200, message: 'En fazla 200 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <ConfirmGroupButton onCancel={props.onCancel} loading={loading} />
      </Form.Item>
    </Form>
  );
}
